var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"home"}},[_c('b-row',[_c('b-col',[_vm._v(" Home ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }